import { WORKSPACE_USER_CACHE_KEYS } from "@hooks/useWorkspaceUserCache";
import { ORGANIZATION_USER_CACHE_KEYS } from "@hooks/useOrganizationUserCache";

type ScopedCacheKey = WORKSPACE_USER_CACHE_KEYS | ORGANIZATION_USER_CACHE_KEYS;

export interface TaskListCacheKeys {
    fullscreenView: ScopedCacheKey;
    baseViewId: ScopedCacheKey;
}

export const WORKSPACE_TASK_LIST_CACHE_KEYS: TaskListCacheKeys = {
    fullscreenView: WORKSPACE_USER_CACHE_KEYS.TASKS_PAGE_VIEW_CACHE_KEY,
    baseViewId: WORKSPACE_USER_CACHE_KEYS.TASKS_PAGE_BASE_VIEW_ID_CACHE_KEY,
};

export const ORGANIZATION_TASK_LIST_CACHE_KEYS: TaskListCacheKeys = {
    fullscreenView:
        ORGANIZATION_USER_CACHE_KEYS.CLIENTS_TASKS_PAGE_VIEW_CACHE_KEY,
    baseViewId:
        ORGANIZATION_USER_CACHE_KEYS.CLIENTS_TASKS_PAGE_BASE_VIEW_ID_CACHE_KEY,
};
